import { useEffect, useState } from "react";
import {
  Row,
  Col,
  Container,
  Cookie,
  CustomContainer,
  useRouter,
} from "../../atoms/DependencyHelper";
import PropTypes from "prop-types";
import ProductViewer from "../../molecules/productViewer/ProductViewer";
import ProductDetailForm from "../../organisms/productDetailForm/productDetailForm";
import ProductDetailsPromotions from "../../molecules/productDetailsPromotions/ProductDetailsPromotions";
import ProductDetailIndicators from "../../organisms/productDetailIndicators/ProductDetailIndicators";
import PageHeading from "../../atoms/pageHeading/PageHeading";
import styles from "./productDetailsBody.module.scss";
import ReactHtmlParser from 'react-html-parser';
import {
  getNestedObjectValue,
  getBadgeName,
  isDiscountTimerApplicable,
  convertToCorrectDateFormat,
  checkIsOutOfStock,
  checkStockQuantity,
  checkIsLowStock,
  getSelectedVariant,
  setCookieConsentWrapper,
  options,
  configurableOptions, numberFormat, createMarkup,
} from "../../../utils/helperServices";
import Tag from "../../atoms/tag/Tag";
import labels from "../../../config/labels";
import Countdown, { zeroPad } from "react-countdown";
import * as Analytics from "../../../services/analyticsUtag";
import { cookie_category } from "../../../config/index";
import { MOBILE_WIDTH } from "../../../config/constants";
import types from "../../../config/types";
import LinkRoute from "../../atoms/linkRoute/LinkRoute";
import config from "../../../config";
import {NumericFormat} from "react-number-format";
const env = config.env;
const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
const imagePrefix = config.envConfigs[env].imagePrefix;
import Image from 'next/image'

const ProductDetailsBody = ({
  productDetails,
  defaultVariant,
  selectedVariant,
  getVariant,
  buyOptions,
  buyOptionTitle,
  getBuyOptionType,
  buyOptionId,
  optList,
  upgradeChecksEnabled,
  triggerCallback,
  showSnackBarEvent,
  closeSnackBarEvent,
  isEligible,
  showModal,
  geoLocationIsAllowed,
  nearestStore,
  isStoreStockServiceDown,
  brand,
  brandId
}) => {
  const [products, setProducts] = useState([]);
  const [rvProducts, setRVProducts] = useState([]); //handle recently viewed products
  let [optListCopy, setOptListCopy] = useState(optList);
  let [optListCopyForDeal, setOptListCopyForDeal] = useState(optList);
  let [listData, setList] = useState([]);
  let [filterVariantsData, setFilterVariantsData] = useState([]);
  const [isStock, setIsStock] = useState();
  const [shareTooltip, setShareTooltip] = useState(false);
  const [shareLabel, setShareLabel] = useState('Copy Link');
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [buyOption, setBuyOption] = useState("");
  const [buyOptionSku, setBuyOptionSku] = useState("");
  const [buyOptionTypeId, setBuyOptionTypeId] = useState("");
  const [checkforId, setCheckForId] = useState(false);
  const [promotionAnalytics, setPromotionAnalytics] = useState("");
  const [videoModalOpened, setVideoModalOpened] = useState(false);
  const handleSelectedOption = (value) => {
    setSelectedOptions(value);
  };
  useEffect(() => {
    getBuyOptionType(buyOptionSku);
  }, [buyOptionSku]);

  useEffect(() => {
    if (
      productDetails &&
      productDetails.configurable_options &&
      buyOptionSku === labels.lbl_custom_dropdown_prepaid_option
    ) {
      setFilterVariantsData([]);
      const optListData = optListOptions(productDetails?.configurable_options);
      if (optListData) {
        const initialObject = Object.values(optListData)[0];
        if (initialObject) {
          updateAttributes(
            Object.keys(initialObject)[0],
            Object.values(initialObject)[0]?.[0]?.label,
            optListData
          );
        }

        let rObj = {};
        optListData?.forEach((obj) => {
          const a = Object.values(obj)[0];
          rObj[Object.keys(obj)] = a[0]?.label;
        });
        handleSelectedOption(rObj);
      }
    }

    if (
      productDetails &&
      productDetails.configurable_options &&
      buyOptionSku !== labels.lbl_custom_dropdown_prepaid_option
    ) {
      setFilterVariantsData([]);
      const dealProductId = productDetails?.deal_data.map(
        (deal) => deal?.product_id
      );
      const variantId = productDetails?.variants.map(
        (variant) => variant?.product?.id
      );

      const checkforId =
        dealProductId.every((e) => variantId.includes(e)) &&
        variantId.every((e) => dealProductId.includes(e));

      if (checkforId) {
        const optListData = optListOptions(
          productDetails?.configurable_options
        );
        const initialObject = Object.values(optListData)[0];
        if (initialObject) {
          updateAttributes(
            Object.keys(initialObject)[0],
            Object.values(initialObject)[0]?.[0]?.label,
            optListData
          );
        }

        let rObj = {};
        optListData?.forEach((obj) => {
          const a = Object.values(obj)[0];
          rObj[Object.keys(obj)] = a[0]?.label;
        });
        handleSelectedOption(rObj);
        setCheckForId(checkforId);
      } else {
        const filterVariants = productDetails?.variants.filter((variant) =>
          productDetails?.deal_data.some(
            (deal) => variant?.product?.id === deal.product_id
          )
        );
        setFilterVariantsData(filterVariants);
        const attrList = [];
        const configValues = (attrCode, label) => {
          const valObj = productDetails?.configurable_options.find(
            (configOption) => {
              return attrCode === configOption.attribute_code;
            }
          );

          return valObj.values.find((val) => val.label === label);
        };

        for (const filterVariant of filterVariants) {
          for (const attr of filterVariant.attributes) {
            attrList.push(configValues(attr.code, attr.label));
          }
        }
        const list = [];
        if (
          productDetails?.__typename ===
          labels.lbl_product_typeName_configurable
        ) {
          let productData;
          try {
            // window.outerWidth <= MOBILE_WIDTH
            if (
              productDetails?.configurable_options?.[1]?.position >
              productDetails?.configurable_options?.[0]?.position
            ) {
              productData = productDetails?.configurable_options.sort(
                (a, b) => b.position - a.position
              );
            } else {
              productData = productDetails?.configurable_options;
            }
          } catch (error) {
            productData = productDetails?.configurable_options;
          }

          const optionsList = configurableOptions(productData);
          optionsList.forEach((option) => {
            const opt = options(productDetails?.configurable_options, option);
            const filterVariants = opt.filter((opt) =>
              attrList.some((att) => opt.label === att.label)
            );
            let some = {};
            some[option] = filterVariants;
            list.push(some);
          });
        }
        setList(list);
        const initialObject = Object.values(list)[0];
        if (initialObject) {
          updateAttributes(
            Object.keys(initialObject)[0],
            Object.values(initialObject)[0]?.[0]?.label,
            list
          );
        }

        let rObj = {};
        list?.forEach((obj) => {
          const a = Object.values(obj)[0];
          rObj[Object.keys(obj)] = a[0]?.label;
        });
        handleSelectedOption(rObj);
      }
    }
  }, [productDetails, buyOptionSku, optList]);

  const handleOptionClick1 = (code, label, optLists) => {
    let newOption = {};
    if (optLists.map((opt) => Object.keys(opt)[0])[0] == code) {
      updateAttributes(code, label, optLists);
    }
    newOption[code[0]] = label;
    optLists.forEach((list) => {
      if (Object.keys(list)[0] != code) {
        const filteredValues = Object.values(list)[0].map(
          (elabel) => elabel.label
        );
        const selectedColorValue = filteredValues.filter(
          (item) => item == selectedOptions.color
        );
        const selectedFilteredValue = filteredValues.filter(
          (item) =>
            item ==
            (selectedOptions.internal_storage ||
              selectedOptions.screen_size_pixels)
        );
        newOption[Object.keys(list)[0]] =
          code != "color"
            ? selectedColorValue[0]
            : selectedFilteredValue && selectedFilteredValue.length
            ? selectedFilteredValue[0]
            : filteredValues[0];
        if (
          filteredValues.indexOf(selectedOptions[Object.keys(list)[0]]) === -1
        ) {
          newOption[Object.keys(list)[0]] = filteredValues[0];
        }
      }
    });
    setSelectedOptions(newOption);
  };

  const updateAttributes = (code, label, optionsList) => {
    const list = [];
    let filterVariantData = [];
    const attrList = [];
    // when deal data and varient data is different implementation
    if (
      buyOptionSku !== labels.lbl_custom_dropdown_prepaid_option &&
      checkforId !== true &&
      buyOptionSku !== ""
    ) {
      filterVariantData = productDetails?.variants.filter((variant) =>
        productDetails?.deal_data.some(
          (deal) => variant?.product?.id === deal.product_id
        )
      );

      const configValues = (attrCode, label) => {
        const valObj = productDetails?.configurable_options.find(
          (configOption) => {
            return attrCode === configOption.attribute_code;
          }
        );

        return valObj.values.find((val) => val.label === label);
      };

      for (const filterVariant of filterVariantData) {
        for (const attr of filterVariant.attributes) {
          attrList.push(configValues(attr.code, attr.label));
        }
      }

      if (
        productDetails?.__typename === labels.lbl_product_typeName_configurable
      ) {
        let productData;
        try {
          // window.outerWidth <= MOBILE_WIDTH
          if (
            productDetails?.configurable_options?.[1]?.position >
            productDetails?.configurable_options?.[0]?.position
          ) {
            productData = productDetails?.configurable_options.sort(
              (a, b) => b.position - a.position
            );
          } else {
            productData = productDetails?.configurable_options;
          }
        } catch (error) {
          productData = productDetails?.configurable_options;
        }

        const optionsList = configurableOptions(productData);
        optionsList.forEach((option) => {
          const opt = options(productDetails?.configurable_options, option);
          const filterVariants = opt.filter((opt) =>
            attrList.some((att) => opt.label === att.label)
          );
          let some = {};
          some[option] = filterVariants;
          list.push(some);
        });
      }
    }

    // TODO: Clean up - remove for each
    const filteredVariantValue = [];
    if (
      buyOptionSku === labels.lbl_custom_dropdown_prepaid_option ||
      checkforId === true
    ) {
      productDetails?.variants.forEach((variant) => {
        variant.attributes.forEach((attr) => {
          if (attr.code == code && attr.label == label) {
            filteredVariantValue.push(variant);
          }
        });
      });
    } else {
      filterVariantData.forEach((variant) => {
        variant.attributes.forEach((attr) => {
          if (attr.code == code && attr.label == label) {
            filteredVariantValue.push(variant);
          }
        });
      });
    }
    const optValuesAtVariantLevel = filteredVariantValue.reduce(
      (acc, item) => [
        ...acc,
        ...item.attributes.filter((variant) => variant.code !== code),
      ],
      []
    );

    filteredVariantValue.forEach((filteredVariant) => {
      filteredVariant?.attributes.forEach((variant) => {
        if (variant.code != code) {
          // 1st: fetch all values of matched variant code from optList
          let optionData = [];
          if (
            filterVariantData.length > 0 &&
            buyOptionSku !== labels.lbl_custom_dropdown_prepaid_option &&
            buyOptionSku !== ""
          ) {
            optionData = list && list.length > 0 ? list : optionsList;
          } else {
            optionData = optListOptions(productDetails?.configurable_options);
          }
          const getVariantCodeAtOpt = optionData.filter(
            (opt) => Object.keys(opt)[0] === variant.code
          );
          let optListFilterValuesByCode = Object.values(
            getVariantCodeAtOpt[0]
          )[0];

          // 2nd: Get filtered varaints for selected option
          // let optValuesAtVariantLevel = filteredVariant.attributes.filter(
          //   (d) => d.code == variant.code
          // );

          // 3rd: Compare with optValuesAtVariantLevel, Remove not matched varaints from optListFilterValuesByCode
          let newShallowOFVaraint = [];
          optListFilterValuesByCode.forEach((val) => {
            let filteredVariantOutput = optValuesAtVariantLevel.filter(
              (variant) => variant.label == val.label
            );
            if (filteredVariantOutput.length) {
              newShallowOFVaraint.push(val);
            }
          });
          // 4th: Update required object of OptList with final filtered data
          const objects = optListOptions(productDetails?.configurable_options);
          let optionsList = [];
          if (
            filterVariantData.length > 0 &&
            buyOptionSku !== labels.lbl_custom_dropdown_prepaid_option &&
            buyOptionSku !== ""
          ) {
            optionsList = list && list.length > 0 ? list : optionsList;
          } else {
            optionsList = objects && objects.length > 0 ? objects : optionsList;
          }

          optionsList.map((copy) => {
            if (Object.keys(copy)[0] == variant.code) {
              return (copy[Object.keys(copy)[0]] = newShallowOFVaraint);
            }
          });
          setOptListCopy(optionsList);
          setOptListCopyForDeal(optionsList);
        } else {
          setOptListCopy(optionsList);
          setOptListCopyForDeal(optionsList);
        }
      });
    });
  };
  const optListOptions = (value) => {
    if (!value?.length) {
      return [];
    }
    let arrValue;
    try {
      // window.outerWidth <= MOBILE_WIDTH
      if (value?.[1]?.position > value?.[0]?.position) {
        arrValue = value.sort((a, b) => b.position - a.position);
      } else {
        arrValue = value;
      }
    } catch (error) {
      arrValue = value;
    }
    return configurableOptions(arrValue).map((option, index) => ({
      [option]: options(productDetails?.configurable_options, option),
    }));
  };

  const handleSelectedBuyOption = (value) => {
    if (
      buyOptionSku === labels.lbl_custom_dropdown_prepaid_option ||
      checkforId === true
    ) {
      const objects = optListOptions(productDetails?.configurable_options);
      const initialObject = Object.values(objects)[0];
      if (initialObject) {
        updateAttributes(
          Object.keys(initialObject)[0],
          Object.values(initialObject)[0]?.[0]?.label,
          objects
        );
      }

      let rObj = {};
      objects?.forEach((obj) => {
        const a = Object.values(obj)[0];
        rObj[Object.keys(obj)] = a[0]?.label;
      });
      handleSelectedOption(rObj);
    } else {
      const productVariants = productDetails?.variants || [];
      const filterVariants = productVariants.filter((variant) =>
        productDetails?.deal_data.some(
          (deal) => variant?.product?.id === deal.product_id
        )
      );

      const attrList = [];
      const configValues = (attrCode, label) => {
        const valObj = productDetails?.configurable_options.find(
          (configOption) => {
            return attrCode === configOption.attribute_code;
          }
        );

        return valObj.values.find((val) => val.label === label);
      };

      for (const filterVariant of filterVariants) {
        for (const attr of filterVariant.attributes) {
          attrList.push(configValues(attr.code, attr.label));
        }
      }
      const list = [];
      if (
        productDetails?.__typename === labels.lbl_product_typeName_configurable
      ) {
        let productData;
        try {
          // window.outerWidth <= MOBILE_WIDTH
          if (
            productDetails?.configurable_options?.[1]?.position >
            productDetails?.configurable_options?.[0]?.position
          ) {
            productData = productDetails?.configurable_options.sort(
              (a, b) => b.position - a.position
            );
          } else {
            productData = productDetails?.configurable_options;
          }
        } catch (error) {
          productData = productDetails?.configurable_options;
        }
        const optionsList = configurableOptions(productData);
        optionsList.forEach((option) => {
          const opt = options(productDetails?.configurable_options, option);
          const filterVariants = opt.filter((opt) =>
            attrList.some((att) => opt.label === att.label)
          );
          let some = {};
          some[option] = filterVariants;
          list.push(some);
        });
      }

      const initialObject = Object.values(list)[0];
      if (initialObject) {
        updateAttributes(
          Object.keys(initialObject)[0],
          Object.values(initialObject)[0]?.[0]?.label,
          list
        );
      }

      let rObj = {};
      list?.forEach((obj) => {
        const a = Object.values(obj)[0];
        rObj[Object.keys(obj)] = a[0]?.label;
      });
      handleSelectedOption(rObj);
    }
    const matchedSku = buyOptions.filter((option) => option.title === value);
    const optionSku = matchedSku.length ? matchedSku[0].sku : buyOptionSku;
    getBuyOptionType(optionSku);
    setBuyOption(value);
    setBuyOptionSku(optionSku);
    setBuyOptionTypeId(
      matchedSku.length ? matchedSku[0].option_type_id : buyOptionTypeId
    );
    Analytics.link({
      ...Analytics.getUtagData([
        "visitor_login_status",
        "visitor_msisdn_hash",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_subscription_type",
      ]),
      page_tool_event: "use",
      page_tool_name:
        "shopping: devices: product details: contract type filter",
      filter_query: value,
      page_name: "shopping: devices: product details",
      sales_product_category: [productDetails?.categories[0]?.name],
      sales_product_id: [productDetails?.name],
      sales_promo_name: [productDetails?.badges_label],
      ...Analytics.getUtagData([
        "visitor_login_status",
        "visitor_subscription_type",
      ]),
      page_site_section_lvl_1: `${productDetails?.name}`,
      page_site_section_lvl_2: `All products`,
      page_site_section_lvl_3: `Home`,
    });
  };

  const setCookieProducts = () => {
    let cookieValue, parsedCookie;
    cookieValue = Cookie.get("products");
    if (cookieValue) {
      parsedCookie = JSON.parse(cookieValue);
    }
    if (!productDetails) {
      setProducts([...parsedCookie]);
      return;
    }
    if (
      parsedCookie &&
      parsedCookie.length === 4 &&
      parsedCookie.every((product) => product.sku !== productDetails.sku)
    ) {
      parsedCookie.pop();
    }

    if (!cookieValue || parsedCookie.length === 0) {
      setProducts([productDetails]);
    }

    if (parsedCookie && parsedCookie.length > 0) {
      const productInCookie = parsedCookie.some(
        (product) => product.sku === productDetails.sku
      );

      const product = parsedCookie.find(
        (cookieProduct) => cookieProduct.sku === productDetails.sku
      );
      const otherCookie = parsedCookie.filter(
        (cookieProduct) => cookieProduct.sku !== productDetails.sku
      );

      productInCookie
        ? setProducts([Object.assign(product, productDetails), ...otherCookie])
        : setProducts([productDetails, ...parsedCookie]);
    }
  };

  const setCookieRecentlyViewedProducts = () => {
    let cookieValue, parsedCookie;
    cookieValue = Cookie.get("rv_products");
    if (cookieValue) {
      parsedCookie = JSON.parse(cookieValue);
    }
    if (!productDetails) {
      setRVProducts([...parsedCookie]);
      return;
    }
    if (
      parsedCookie &&
      parsedCookie.length === 4 &&
      parsedCookie.every((product) => product.sku !== productDetails.sku)
    ) {
      parsedCookie.pop();
    }

    if (!cookieValue || parsedCookie.length === 0) {
      setRVProducts([productDetails]);
    }

    if (parsedCookie && parsedCookie.length > 0) {
      const productInCookie = parsedCookie.some(
        (product) => product.sku === productDetails.sku
      );

      const product = parsedCookie.find(
        (cookieProduct) => cookieProduct.sku === productDetails.sku
      );
      const otherCookie = parsedCookie.filter(
        (cookieProduct) => cookieProduct.sku !== productDetails.sku
      );

      productInCookie
        ? setRVProducts([
            Object.assign(product, productDetails),
            ...otherCookie,
          ])
        : setRVProducts([productDetails, ...parsedCookie]);
    }
  };

  useEffect(() => {
    if (products && products.length) {
      const productCookie = products.map((product) => {
        let variantConfig;
        const obj = {
          sku: product.sku,
        };

        if (
          productDetails?.__typename ===
            labels.lbl_product_typeName_configurable &&
          selectedVariant &&
          product.sku === productDetails.sku
        ) {
          obj.variantConfig = { ...selectedOptions, sku: productDetails?.sku };
        } else {
          variantConfig =
            product && product.variantConfig ? product.variantConfig : null;
          obj.variantConfig = variantConfig;
        }
        return obj;
      });
      setCookieConsentWrapper(
        "products_cookie",
        [cookie_category.strictly_necessary],
        `document.cookie='products=${encodeURIComponent(
          JSON.stringify(productCookie).replace(/'/g, "\\'")
        )};path=/'`
      );
    }
  }, [products]);

  useEffect(() => {
    if (rvProducts && rvProducts.length) {
      const productCookie = products.map((product) => {
        let variantConfig;
        const obj = {
          sku: product.sku,
        };

        if (
          productDetails?.__typename ===
            labels.lbl_product_typeName_configurable &&
          selectedVariant &&
          product.sku === productDetails.sku
        ) {
          obj.variantConfig = { ...selectedOptions, sku: productDetails?.sku };
        } else {
          variantConfig =
            product && product.variantConfig ? product.variantConfig : null;
          obj.variantConfig = variantConfig;
        }
        return obj;
      });
      setCookieConsentWrapper(
        "products_rv_cookie",
        [cookie_category.strictly_necessary],
        `document.cookie='rv_products=${encodeURIComponent(
          JSON.stringify(productCookie).replace(/'/g, "\\'")
        )};path=/'`
      );
    }
  }, [rvProducts]);

  const getProductforBadge = () => {
    if (selectedVariant) {
      return selectedVariant.product;
    }
    if (productDetails?.__typename === labels.lbl_product_type_bundle) {
      return productDetails?.items[0]?.options[0]?.product;
    }
    if (productDetails?.__typename === labels.lbl_product_typeName_simple) {
      return productDetails;
    }
  };
  // refactoring to stateless component
  const isConfigurable = (productDetails) => {
    return (
      productDetails.__typename === labels.lbl_product_typeName_configurable &&
      productDetails?.configurable_options?.length > 0
    );
  };
  const getPromoInfo = () => {
    // check if has variants
    const promoData = {};
    if (isConfigurable(productDetails)) {
      setPromotionAnalytics(selectedVariant?.product?.badges_label);
      promoData.promoTag = selectedVariant?.product?.badges_label
        ? selectedVariant?.product?.badges_label
        : productDetails?.badges_label;
      promoData.promotionLink = selectedVariant?.product?.promotion_link
        ? selectedVariant?.product?.promotion_link
        : productDetails?.promotion_link;
      promoData.promoId = selectedVariant?.product?.badges
        ? selectedVariant?.product?.badges
        : productDetails?.badges;
      promoData.promoEndDate = selectedVariant?.product?.promotions?.end_date
        ? selectedVariant?.product?.promotions?.end_date
        : productDetails?.promotions?.end_date;
      promoData.promoTagColor = selectedVariant?.product?.badges_swatch
        ? selectedVariant?.product?.badges_swatch
        : productDetails?.badges_swatch;
    } else {
      setPromotionAnalytics(productDetails?.badges_label);
      promoData.promoTag = productDetails?.badges_label;
      promoData.promotionLink = productDetails?.promotion_link;
      promoData.promoId = productDetails?.badges;
      promoData.promoEndDate = productDetails?.promotions?.end_date;
      promoData.promoTagColor = productDetails?.badges_swatch;
    }
    return promoData;
  };

  const getAmounts = () => {
    const amountData = {};
    if (isConfigurable(productDetails)) {
      amountData.currentPrice = selectedVariant
        ? getNestedObjectValue(selectedVariant, [
            "product",
            "price_range",
            "maximum_price",
            "final_price",
            "value",
          ])
        : null;
      amountData.oldPrice = selectedVariant
        ? getNestedObjectValue(selectedVariant, [
            "product",
            "price_range",
            "maximum_price",
            "regular_price",
            "value",
          ])
        : null;
      amountData.discount = selectedVariant
        ? getNestedObjectValue(selectedVariant, [
            "product",
            "price_range",
            "maximum_price",
            "discount",
            "amount_off",
          ])
        : null;

      let variantId = selectedVariant?.product?.id;
      let variantDealData = productDetails?.deal_data.filter(
        (obj) => obj.product_id === variantId
      );
      if (variantDealData.length > 0) {
        amountData.variantDealPrice = Math.round(variantDealData[0]?.min_price);
        amountData.variantDeviceInstallment = Math.round(
          variantDealData[0]?.deal_installment
        );
      }
    } else {
      amountData.currentPrice = Math.round(
        getNestedObjectValue(productDetails?.price_range, [
          "maximum_price",
          "final_price",
          "value",
        ])
      );
      amountData.oldPrice = Math.round(
        getNestedObjectValue(productDetails?.price_range, [
          "maximum_price",
          "regular_price",
          "value",
        ])
      );
      amountData.discount = Math.round(
        getNestedObjectValue(productDetails?.price_range, [
          "maximum_price",
          "discount",
          "amount_off",
        ])
      );
      amountData.variantDealPrice = Math.round(
        productDetails?.deal_data[0]?.min_price
      );
      amountData.variantDeviceInstallment = Math.round(
        productDetails?.deal_data[0]?.deal_installment
      );
    }
    return amountData;
  };

  const showDiscountTimer = () => {
    if (isConfigurable(productDetails)) {
      return isDiscountTimerApplicable(selectedVariant?.product?.promotions);
    } else {
      return isDiscountTimerApplicable(productDetails?.promotions);
    }
  };

  const getMediaGallery = () => {
    let mediaGallery = [];
    if (isConfigurable(productDetails)) {
      mediaGallery =
        selectedVariant && selectedVariant?.product?.media_gallery?.length > 0
          ? selectedVariant.product.media_gallery
              .sort((image1, image2) => image1?.position - image2?.position)
              .slice(0, 8)
          : selectedVariant?.product?.image
          ? [selectedVariant.product.image]
          : [];
    } else {
      mediaGallery =
        productDetails && productDetails.media_gallery.length > 0
          ? productDetails.media_gallery
              .sort((image1, image2) => image1?.position - image2?.position)
              .slice(0, 8)
          : productDetails?.image
          ? [productDetails.image]
          : [];
    }
    return mediaGallery;
  };

  const renderDeliveryReturn = () => {
    const showConfigurable = (selectedVariant || defaultVariant) &&
        productDetails?.["__typename"] === labels.lbl_product_typeName_configurable;
    const showSimple = productDetails?.["__typename"] === labels.lbl_product_typeName_simple;

    let toRender = false;
    let content = '';

    if (showConfigurable) {
      toRender = true;
      content = selectedVariant?.product?.delivery_and_return;
    }

    if (showSimple) {
      toRender = true;
      content = productDetails?.delivery_and_return;
    }

    return toRender && (
        <CustomContainer className={styles.deliveryOption}>
          {/*<div className={styles.deliveryOptionTitle}>Delivery options</div>*/}
          {/*<div className={styles.deliveryOptionSub}>Select at checkout</div>*/}
          <div dangerouslySetInnerHTML={{
                __html: content
              }}
          ></div>
        </CustomContainer>
    );
  };

  const [bodyState, setBodyState] = useState({
    promoTag: "",
    promoId: "",
    promotionLink: "",
    promoEndDate: null,
    mediaGallery: [],
    displayDiscountTimer: null,
    showShopCheck: false,
  });

  const router = useRouter();

  const setDefaultBuyOption = (optionSku) => {
    const optionIndex = buyOptions?.findIndex((option) =>
      option.sku.includes(optionSku)
    );
    getBuyOptionType(buyOptions?.[optionIndex]?.sku);
    setBuyOption(buyOptions?.[optionIndex]?.title);
    setBuyOptionSku(buyOptions?.[optionIndex]?.sku);
    setBuyOptionTypeId(buyOptions?.[optionIndex]?.option_type_id);
  };

  const scrollToSpecs = () => {
    var element = document.getElementById('specifications'),
        offset = 180,
        elementPosition = element.getBoundingClientRect().top,
        offsetPosition = elementPosition + window.pageYOffset - offset;

    element.click();

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  };

  const openVideoModal = (status) => {
    if (status) {
      document.querySelector('body').classList.add('no-scroll');
    } else {
      document.querySelector('body').classList.remove('no-scroll');
    }

    setVideoModalOpened(status);
  };

  const shareUrl = () => {
    const url = window.location.href;
    const tempInput = document.createElement('textarea');
    tempInput.value = url;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);

    setShareLabel('Copied');

    setTimeout(function() {
      setShareLabel('Copy link');
      setShareTooltip(false);
    }, 3000)
  };

  useEffect(() => {
    if (productDetails) {
      setCookieProducts();
      setCookieRecentlyViewedProducts();
    }

    const filteredVariants = [];
    const isStockList = [];
    // simple product
    if (
      productDetails?.deal_data?.length > 0 &&
      productDetails?.deal_data[0]?.min_price &&
      productDetails?.deal_data[0]?.deal_installment &&
      isEligible
    ) {
      setDefaultBuyOption("upgrade");
    } else if (router?.query?.monthlyPrice) {
      setDefaultBuyOption("contract");
    } else {
      setDefaultBuyOption("once-off");
    }
    // configurable product
    if (productDetails?.variants && productDetails?.variants.length) {

      productDetails?.variants?.forEach((variant) => {
        filteredVariants.push(variant.product);
      });
      filteredVariants.map((stock) => {
        isStockList.push(stock.stock_status);
      });
      const dataflag = checkStockQuantity(productDetails);
      if (dataflag === false) {
        setIsStock(false);
      } else {
        setIsStock(true);
        if (isEligible) {
          setDefaultBuyOption("upgrade");
        } else if (
          productDetails?.deal_data?.length > 0 &&
          productDetails?.deal_data[0]?.min_price &&
          productDetails?.deal_data[0]?.deal_installment
        ) {
          setDefaultBuyOption("contract");
        } else {
          setDefaultBuyOption("once-off");
        }
      }
    }
  }, [productDetails]);

  useEffect(() => {
    if (productDetails || selectedVariant) {
      setBodyState({
        ...bodyState,
        ...getPromoInfo(),
        ...getAmounts(),
        mediaGallery: getMediaGallery(),
        displayDiscountTimer: showDiscountTimer(),
      });
    }
  }, [selectedVariant]);

  useEffect(() => {
    if (selectedOptions) {
      let newVariant = getSelectedVariant(
        productDetails.variants,
        selectedOptions
      );
      if (newVariant) {
        getVariant(newVariant);
      }
    }
  }, [selectedOptions]);

  return (
    <div>
      <div className={styles["wrapper"]}>
        <div className={styles["wrapper-device"]}>
          {bodyState.promoTag && bodyState.promoLink != null ? (
            <CustomContainer className="absolute left-6 xl:left-4 xl:top-4">
              <Tag
                label={
                  bodyState.promoTag == types.TYPE_PREORDER
                    ? labels.lbl_pre_order_online_exclusive_tag
                    : bodyState.promoTag
                }
                variant={getBadgeName(bodyState.promoTag)}
                labelColor={bodyState.promoTagColor}
                className={`${styles["offer-style"]} text-center`}
              />
            </CustomContainer>
          ) : (
            ""
          )}
          <ProductViewer
            mediaGallery={bodyState.mediaGallery}
            className={styles["product-viewer"]}
            sku={productDetails?.sku}
          />
        </div>
        <div
          className={`${styles["product-details"]}`}
        >
          {brand && (
            <a className={styles.brandLogo} href={`${urlPrefix}/products?brands=${
              brandId?.toString() + ":" + brand
            }`}>
              <Image width={120} height={130} alt={brand} src={`${imagePrefix}/assets/images/brands/${brand.toLowerCase().trim()}.png`} onError={(e)=>{e.target.onError = null; e.target.parentNode.classList.add('no-brand-found');}}/>
            </a>
          )}
          <div className={styles.shareWrapper}>
            <div onClick={() => setShareTooltip(!shareTooltip)} className={`${styles.shareButton} ${shareTooltip ? 'bg-[#EBEDEF]' : ''}`}></div>
            <div className={`${shareTooltip ? 'block' : 'hidden'} share-tooltip`}>
              <div onClick={() => shareUrl()}>{shareLabel}</div>
            </div>
          </div>
          <div className={styles.titleContainer}>
            <PageHeading
              id={`${productDetails?.name.replace(brand, '')}-ProductNameHeader`}
              text={productDetails?.name.replace(brand, '')}
              className={`${styles["product-details-heading"]} !font-VodafoneExB !text-[#08081B] !text-[32px] xl:!text-[64px] !leading-[38px] xl:!leading-[78px]`}
            />
          </div>
          <div className={styles.productPrice}>
            From <NumericFormat
              displayType="text"
              value={numberFormat(bodyState.variantDealPrice)}
              prefix={'R'}
              thousandSeparator={true}
            /> PM / {' '}
            <NumericFormat
              displayType="text"
              value={numberFormat(bodyState.currentPrice)}
              prefix={'R'}
              thousandSeparator={true}/>
          </div>
          <div className={styles.productActionShortcuts}>
              <div onClick={() => scrollToSpecs()} className={styles.viewSpecsShortcut}><span>View specs</span></div>
              {productDetails.video_url && (
                <div onClick={() => openVideoModal(true)} className={styles.videoShortcut}><span>Watch video</span></div>
              )}
          </div>
          <ProductDetailForm
            optList={
              buyOptionSku === labels.lbl_custom_dropdown_prepaid_option
                ? optListCopy
                : optListCopyForDeal
            }
            selectedVariant={selectedVariant}
            productDetails={productDetails}
            handleOptionClick1={handleOptionClick1}
            currentPrice={bodyState.currentPrice}
            oldPrice={bodyState.oldPrice}
            discount={bodyState.discount}
            variantDealPrice={bodyState.variantDealPrice}
            variantDeviceInstallment={bodyState.variantDeviceInstallment}
            buyOption={buyOption}
            buyOptions={buyOptions}
            buyOptionSku={buyOptionSku}
            buyOptionTitle={buyOptionTitle}
            handleSelectedBuyOption={handleSelectedBuyOption}
            buyOptionId={buyOptionId}
            buyOptionTypeId={buyOptionTypeId}
            displayDiscountTimer={bodyState.displayDiscountTimer}
            date={
              productDetails.__typename ===
              labels.lbl_product_typeName_configurable
                ? convertToCorrectDateFormat(
                  selectedVariant?.product?.promotions?.end_date
                )
                : convertToCorrectDateFormat(
                  productDetails?.promotions?.end_date
                )
            }
            selectedOptions={selectedOptions}
            upgradeChecksEnabled={upgradeChecksEnabled}
            triggerCallback={triggerCallback}
            showSnackBarEvent={showSnackBarEvent}
            closeSnackBarEvent={closeSnackBarEvent}
            promotionTag={bodyState.promoTag}
            showShopCheck={bodyState.showShopCheck}
            geoLocationIsAllowed={geoLocationIsAllowed}
            nearestStore={nearestStore}
            isStoreStockServiceDown={isStoreStockServiceDown}
          />
          {productDetails.video_url && (
            <>
              <div className={`${styles.videoModalOverlay} ${videoModalOpened ? 'block' : 'hidden'}`}></div>
              <div className={`${styles.videoModal} ${videoModalOpened ? 'block' : 'hidden'}`}>
                <div onClick={() => openVideoModal(false)} className={styles.videoModalClose}>Close Video</div>
                <div className={styles.videoModalContent}>
                  {videoModalOpened && (
                    <video src={productDetails.video_url} controls autoPlay muted></video>
                  )}
                </div>
              </div>
            </>
          )}
          {productDetails.pdp_best_features && (
            <div className={styles.deliveryOptionsWrapper}>
              <div className={styles.deliveryInfoTitle}>
                Best features
              </div>
              <div className={styles.specialFeaturesWrapper}>{ReactHtmlParser(productDetails.pdp_best_features)}
              </div>
            </div>
          )}
          <div className={styles.deliveryOptionsWrapper}>
            <div className={styles.deliveryInfoTitle}>
            Delivery options
            </div>
            <div className={`${styles.deliveryOptionsWapper} ${styles.cncOptionsWrapper}`}>
              <div className={styles.deliveryOptionTitle}>Delivery to an address</div>
              <div className={styles.deliveryOptionDescription}>
                Delivered anywhere in SA within 2 days of placing your order. Delivery costs based on your location.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ProductDetailsBody.propTypes = {
  productDetails: PropTypes.object,
  geoLocationIsAllowed: PropTypes.bool,
  showModal: PropTypes.func,
  isStoreStockServiceDown: PropTypes.bool,
};

export default ProductDetailsBody;
